import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import styles from './Store.module.css';
import RulesModal from "./RulesModal";

import { registerStoreService } from "../../../services/customerService";
import { toEnglishNumbers } from "../../../utils/datePicker";
import { showErrorMessage } from "../../../services/httpService";
import { errorMessage, successMessage } from "../../../utils/message";

const RegisterStore = ({
   data,
   setData,
   section,
   rules,
   setRules,
   handelChange,
   prevSection,
}) => {
   const navigate = useNavigate();
   const allCompleted = data.details.rules && data.details.requestText;

   const { executeRecaptcha } = useGoogleReCaptcha();
   const handleReCaptchaVerify = useCallback(async () => {
      if (!executeRecaptcha) return;
      const token = await executeRecaptcha();
      return token;
   }, [executeRecaptcha]);

   const handelRegisterStore = async () => {
      if (!data.details.rules) {
         return errorMessage("برای ثبت فروشگاه باید قوانین را بپذیرید!");
      }
      if (
         !data.details.storeName || !data.details.storeNameEn || !data.details.storeType
         || !data.details.cooperationType || !data.details.storePostalCode ||
         !data.details.storePhoneNumber || !data.details.managerName || !data.details.managerNationalId
         || !data.details.managerNationalIdSerial || !data.details.managerBirthDate ||
         !data.details.managerPhoneNumber || !data.details.stateId || !data.details.cityId
         || !data.details.postUnitId || !data.details.postNodeId || !data.details.aboutStore ||
         !data.details.requestText
      ) {
         return errorMessage('لطفا همه اطلاعات را وارد کنید!');
      }
      if (data.details.fileList.length === 0) {
         return errorMessage("لطفا لوگوی فروشگاه را آپلود کنید!");
      }
      const captchaToken = await handleReCaptchaVerify();
      const res = await registerStoreService({
         ...data,
         details:
            { ...data.details, managerBirthDate: toEnglishNumbers(data.details.managerBirthDate) }
      }, captchaToken);
      if (res.error) {
         return showErrorMessage(res);
      } else {
         successMessage("فروشگاه شما باموفقیت ثبت شد");
         setTimeout(() => {
            navigate(`/request-details/${res.data.id}`);
            navigate(`/requests`);
         }, 1000);
      }
   };

   return (
      <div
         style={{ minHeight: 'fit-content' }}
         className={section === 3 ? "progresstabs__content active-nav" : "progresstabs__content"}
      >
         <h1 className="progresstabs__content-title">شرح درخواست</h1>

         <div
            className={`progresstabs__content-receiver ${styles.fields}`}
         >
            {/* متن درخواست  */}
            <div
               style={{ flex: '0 0 100%', margin: '0 0 2rem', padding: '4px 0.7rem' }}
               className="progresstabs__content-receiver-content progresstabs__content-receiver-content--address"
            >
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`} style={{ fontSize: "15px" }}>
                  متن درخواست خود را وارد کنید :
                  <textarea
                     style={{ minHeight: '200px' }}
                     className="progresstabs__content-receiver-input"
                     name=''
                     value={data.details.requestText}
                     onChange={handelChange}
                  />
               </label>
            </div>
            {/* قوانین و مقررات  */}
            <div style={{ display: "flex", alignItems: "center", gap: '4px', padding: '13rem 0.7rem 4px' }}>
               <input
                  style={{ width: '20px', height: '20px', cursor: 'pointer', accentColor: '#21164b' }}
                  type="checkbox"
                  checked={data.details.rules}
                  onChange={(e) => setData(prev => ({ ...prev, details: { ...prev.details, rules: e.target.checked } }))}
               />
               <p style={{ fontSize: "15px" }}>
                  <span
                     onClick={() => setRules(prev => ({ ...prev, show: true }))}
                     style={{
                        paddingRight: "6px",
                        color: "#fe5900",
                        cursor: "pointer",
                        textDecoration: "underline"
                     }}
                  >قوانین</span> را مطالعه کرده و می‌پذیرم
               </p>
            </div>
         </div>
         <div className="progresstabs__content-buttons" style={{ gap: '16px' }}>
            {/* <button
               className={`btn btn--secondary return-btn ${styles.btn}`}
               onClick={prevSection}
            >
               بازگشت
            </button> */}
            <button
               style={{
                  height: '50px',
                  padding: '1rem 2rem',
                  minWidth: '135px',
                  borderRadius: '4px',
                  outline: 'none',
                  border: 'none',
                  color: '#fff',
                  cursor: 'pointer',
                  background: '#21164b',
               }}
               // className={`btn btn--secondary next-btn ${styles.btn}`}
               onClick={prevSection}
            >
               بازگشت
            </button>
            <button
               style={{
                  height: '50px',
                  padding: '1rem 2rem',
                  minWidth: '135px',
                  borderRadius: '4px',
                  outline: 'none',
                  border: 'none',
                  color: '#fff',
                  cursor: 'pointer',
                  background: '#21164b',
                  ...(allCompleted ? {} : { opacity: '0.7' })
               }}
               // className={`btn btn--secondary next-btn ${styles.btn}`}
               onClick={allCompleted ? handelRegisterStore : undefined}
            >
               ثبت فروشگاه
            </button>
         </div>
         {/* مدال قوانین و مقررات  */}
         {rules.show &&
            <RulesModal
               text={rules.text}
               closeModal={() => setRules(prev => ({ ...prev, show: false }))}
            />
         }
      </div >
   );
};

export default RegisterStore;